export const API_URL =
  import.meta.env.VITE_API_URL || "http://localhost:3001/api";
export const PRIVY_APP_ID = import.meta.env.VITE_PRIVY_APP_ID || "";
export const APP_NAME = import.meta.env.VITE_APP_NAME || "Befit";

// Error Monitoring
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";

// Smart Contract Addresses
export const DASHER_FACTORY_ADDRESS =
  import.meta.env.VITE_DASHER_FACTORY_ADDRESS ||
  "0x8b674795B18508B9aC443A8E76dC6829B51B0786s";

// Alchemy Account Abstraction Configuration
export const ALCHEMY_API_KEY =
  import.meta.env.VITE_ALCHEMY_API_KEY || "txntl9XYKWyIkkmj1p0JcecUKxqt9327";
export const ALCHEMY_GAS_POLICY_ID =
  import.meta.env.VITE_ALCHEMY_GAS_POLICY_ID ||
  "e92be839-07f7-4be1-ae31-55fe7e2a7185";
export const CHAIN_ID = parseInt(import.meta.env.VITE_CHAIN_ID || "8453"); // Base Mainnet

export const ROUTES = {
  HOME: "/",
  CHALLENGES: "/challenges",
  CREATE_CHALLENGE: "/create-challenge",
  CHALLENGE_DETAIL: "/challenge/:id",
  PROFILE: "/profile",
  LOGIN: "/login",
} as const;

export const STEP_GOALS = {
  EASY: 5000,
  MEDIUM: 10000,
  HARD: 15000,
} as const;

export const CHALLENGE_DURATIONS = {
  WEEK: 7,
  TWO_WEEKS: 14,
  MONTH: 30,
} as const;
